import React from 'react';
import Button from '../../../components/ui/Button';


const CategoryTabs = ({ activeCategory, onCategoryChange }) => {
  const categories = [
    { id: 'all', label: 'All Products', icon: 'Grid3X3', count: 312 },
    { id: 'shoes', label: 'Shoes', icon: 'Footprints', count: 156 },
    { id: 'clothes', label: 'Clothes', icon: 'Shirt', count: 89 },
    { id: 'bags', label: 'Bags', icon: 'ShoppingBag', count: 67 }
  ];

  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {categories?.map((category) => (
        <Button
          key={category?.id}
          variant={activeCategory === category?.id ? 'default' : 'outline'}
          onClick={() => onCategoryChange(category?.id)}
          iconName={category?.icon}
          iconPosition="left"
          className="flex-shrink-0"
        >
          <span>{category?.label}</span>
          <span className={`ml-2 px-2 py-0.5 rounded-full text-xs ${
            activeCategory === category?.id
              ? 'bg-primary-foreground/20 text-primary-foreground'
              : 'bg-muted text-muted-foreground'
          }`}>
            {category?.count}
          </span>
        </Button>
      ))}
    </div>
  );
};

export default CategoryTabs;